import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-price-summary-field',
    templateUrl: './price-summary-field.component.html',
})
export class PriceSummaryFieldComponent implements OnInit {

    @Input() label: string;
    @Input() price: number;
    @Input() color: string;
    @Input() iconName: string;

    constructor() {
    }

    ngOnInit() {
    }

}
